import { render, staticRenderFns } from "./BonusWheel.vue?vue&type=template&id=b55b0976&scoped=true&"
import script from "./BonusWheel.vue?vue&type=script&lang=js&"
export * from "./BonusWheel.vue?vue&type=script&lang=js&"
import style0 from "./BonusWheel.vue?vue&type=style&index=0&id=b55b0976&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55b0976",
  null
  
)

export default component.exports